// extracted by mini-css-extract-plugin
export default {"table":"style_table__kSfR8","columns":"style_columns__yKlpI","full":"style_full__55EYf","skeletonTable":"style_skeletonTable__johZ8"};